// This file was autogenerated with oarepo-tools
import TRANSLATE_CS from "./cs/LC_MESSAGES/translations.json"
import TRANSLATE_EN from "./en/LC_MESSAGES/translations.json"
export const translations = {
    cs: { translation: TRANSLATE_CS },
    en: { translation: TRANSLATE_EN },
}
